import { createApp } from 'vue';
import App from "/src/App.vue";
import store from "/src/store";
import LifetimeIframeControl from '/src/config/LifetimeIframeControl.js';
import LifetimeHelpers from '/src/config/LifetimeHelpers.js'
import filters from '/src/filters';
import clientConfig from '/src/config/client.js';
import VueGtag from "vue-gtag";
import { createGtm } from '@gtm-support/vue-gtm';

import '/src/scss/main.scss';

const app = createApp(App)

app.config.globalProperties.$filters = filters;

app
  .use(LifetimeIframeControl, {
    divId: "app",
    clientConfig: clientConfig
  })
  .use(LifetimeHelpers, {
    clientConfig: clientConfig
  })
  .use(createGtm({
    id: clientConfig.analytics.gtmcode, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }))
  .use(VueGtag, {
    appName: 'Hitting the Target',
    pageTrackerScreenviewEnabled: true,
    includes: [
      { id: clientConfig.analytics.gacode },
    ],
    config: {
      id: 'G-KQG4N84HK1',
      cookie_flags: 'SameSite=None;Secure',
      params: {
        send_page_view: true,
        debug_mode: false
      }
    }
  })
  .use(store)
  .mount('#app');
